import { StyleSheet } from 'react-native-web';

export default StyleSheet.create({
  container: {
    maxWidth: '25rem',
    margin: '0.5rem',
    paddingRight: '1rem',
  },
  title: {
    fontWeight: 700,
    fontSize: '19px',
    lineHeight: '25px',
  },
  row: {
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  infoBox: {
    paddingTop: '11px',
  },
  label: {
    fontWeight: 700,
  },
});
